module.exports = __webpack_public_path__ + "img/logo_white.d31dd690.svg";